import { Icon } from '@iconify/react';
import { Avatar, Box, Card, Divider, Grid, IconButton, Typography } from '@mui/material';
import React from 'react';

function UserCard({ dataUser, hadnleHostUserSelect, hostUserSelected }) {
  const { displayName, email, id, photoURL, role } = dataUser;

  const sendHostUserId = () => {
    hadnleHostUserSelect(dataUser.id);
  };

  return (
    <Grid item xs={12} md={6}>
      <Card
        onClick={sendHostUserId}
        sx={{ padding: '15px', display: 'flex', gap: '15px', alignItems: 'center', height: '100%', cursor: 'pointer' }}
      >
        <Avatar src={photoURL} />
        <Box>
          <Typography variant="subtitle2">{displayName}</Typography>
          <Divider />
          <Typography variant="subtitle2" fontSize="13px">
            {email}
          </Typography>
          <Divider />
          <Typography variant="subtitle2" fontSize="13px">
            {role}
          </Typography>
          <Box>
            {hostUserSelected === dataUser.id && (
              <IconButton color="info">
                <Icon icon="eva:checkmark-circle-2-fill" />
              </IconButton>
            )}
          </Box>
        </Box>
      </Card>
    </Grid>
  );
}

export default UserCard;
